/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BookmarksSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M160.00586,56h-96a16.01833,16.01833,0,0,0-16,16V224a8.00026,8.00026,0,0,0,12.65039,6.50977L111.999,193.83105l51.35743,36.67872A7.99952,7.99952,0,0,0,176.00586,224V72A16.01833,16.01833,0,0,0,160.00586,56Z" />
        <Path d="M192.00586,24h-104a8,8,0,0,0,0,16h104V192a8,8,0,0,0,16,0V40A16.01833,16.01833,0,0,0,192.00586,24Z" />
      </G>
    </Svg>
  );
}

export default BookmarksSimple;
